import { WMCircularProgress, WMIconWarning, WMSkeleton } from '@walkme/wm-ui';
import classes from './AppTableRow.module.scss';
import React, { useContext } from 'react';
import { AppTableContext } from '../AppTableContext';
import { AppTableRowAnimateType, IAppTableRowData } from '../model';

export enum AppTableRowStatus {
    loading = 'loading',
    error = 'error'
}

const AppTableRow = ({ rowData, cells, columns }: { rowData: IAppTableRowData; cells: JSX.Element[]; columns: $TSFixMe[] }) => {
    const { loading, tableDataTestid, animateIds } = useContext(AppTableContext);

    return (
        <>
            {cells.map((cell: $TSFixMe) => {
                const column = columns.find(({ dataKey }) => cell?.key.includes(dataKey));

                if (rowData?.[column?.dataKey] === AppTableRowStatus.error) {
                    return (
                        <div key={cell?.key} {...cell?.props}>
                            <WMIconWarning size={16} color="var(--wmError)" />
                        </div>
                    );
                }

                if ((loading || rowData?.[column?.dataKey] === AppTableRowStatus.loading) && column.skeleton) {
                    return (
                        <div key={cell?.key} {...cell?.props}>
                            <WMSkeleton variant="text" animation="wave" {...column.skeleton} />
                        </div>
                    );
                }

                return cell;
            })}
            {animateIds.get(rowData.id) === AppTableRowAnimateType.process && (
                <div className={classes.processingRowDiv} data-testid={`${rowData.id}-processing-row-${tableDataTestid}`}>
                    <WMCircularProgress />
                </div>
            )}
        </>
    );
};

export default AppTableRow;
